/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSpreadsheetConfigDto } from '../../models/backend-spreadsheet-config-dto';

export interface SalesSpreadsheetRetrieve$Params {
  id: number;
}

export function salesSpreadsheetRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: SalesSpreadsheetRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
  const rb = new RequestBuilder(rootUrl, salesSpreadsheetRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSpreadsheetConfigDto>;
    }),
  );
}

salesSpreadsheetRetrieve.PATH = '/api/sales/spreadsheet/{id}';
